import { PlatesSteps } from '@/common/variables';

export const stepsFlow = [
  {
    type: PlatesSteps.intro,
    body: 'Intro / Company Agent Value Props',
    index: 1,
  },
  {
    type: PlatesSteps.occupation,
    body: 'Occupation Plate',
    index: 2,
  },
  {
    type: PlatesSteps.analysis,
    body: 'Needs Analysis',
    index: 3,
  },
  {
    type: PlatesSteps.needs,
    body: 'Needs Summary',
    index: 4,
  },
  {
    type: PlatesSteps.process,
    body: 'Process Plate',
    index: 5,
  },
  {
    type: PlatesSteps.basicInfo,
    body: 'Basic info verify w/ income',
    index: 6,
  },
  {
    type: PlatesSteps.health,
    body: "Knock out Health Q's = Guaranteed",
    index: 7,
  },
  {
    type: PlatesSteps.generalHealth,
    body: 'General Health Conditions',
    index: 8,
  },
  {
    type: PlatesSteps.company,
    body: 'Company value prop',
    index: 9,
  },
  {
    type: PlatesSteps.product,
    body: 'Product Value Props',
    index: 10,
  },
  {
    type: PlatesSteps.result,
    body: 'Pitch w/ rebuttals',
    index: 11,
  },
  {
    type: PlatesSteps.email,
    body: 'Email plate',
    index: 12,
  },
  {
    type: PlatesSteps.beneficiary,
    body: 'Beneficiary Page',
    index: 13,
  },
  {
    type: PlatesSteps.payment,
    body: 'Payment Page',
    index: 14,
  },
  {
    type: PlatesSteps.summary,
    body: 'Summary Page',
    index: 15,
  },
];

export const disabledStepsFlow = [
  {
    type: PlatesSteps.intro,
    body: 'Intro / Company Agent Value Props',
    index: 1,
  },
  {
    type: PlatesSteps.occupation,
    body: 'Occupation Plate',
    index: 2,
  },
  {
    type: PlatesSteps.disabledAnalysis,
    body: 'Disabled Needs Analysis',
    index: 3,
  },
  {
    type: PlatesSteps.disabledNeeds,
    body: 'Disabled Needs Summary',
    index: 4,
  },
  {
    type: PlatesSteps.process,
    body: 'Process Plate',
    index: 5,
  },
  {
    type: PlatesSteps.basicInfo,
    body: 'Basic info verify w/ income',
    index: 6,
  },
  {
    type: PlatesSteps.health,
    body: "Knock out Health Q's = Guaranteed",
    index: 7,
  },
  {
    type: PlatesSteps.disabledHealthFirst,
    body: 'FE level = Graded',
    index: 8,
  },
  {
    type: PlatesSteps.disabledHealthSecond,
    body: 'FE if yes Standard; if no = preferred',
    index: 9,
  },
  {
    type: PlatesSteps.generalHealth,
    body: 'General Health Conditions',
    index: 10,
  },
  {
    type: PlatesSteps.company,
    body: 'Company value prop',
    index: 11,
  },
  {
    type: PlatesSteps.product,
    body: 'Product Value Props',
    index: 12,
  },
  {
    type: PlatesSteps.result,
    body: 'Pitch w/ rebuttals',
    index: 13,
  },
  {
    type: PlatesSteps.email,
    body: 'Email plate',
    index: 14,
  },
  {
    type: PlatesSteps.beneficiary,
    body: 'Beneficiary Page',
    index: 15,
  },
  {
    type: PlatesSteps.payment,
    body: 'Payment Page',
    index: 16,
  },
  {
    type: PlatesSteps.summary,
    body: 'Summary Page',
    index: 17,
  },
];

